import { Anchor, createStyles, List, Modal, rem } from "@mantine/core";
import { useCurrentUser } from "hooks/useCurrentUser";

const useStyles = createStyles(() => ({
  anchor: {
    color: "white",
    display: "flex",

    "&:hover": {
      backgroundColor: "#DDEDFF14",
      color: "white",
      textDecoration: "none",
    },
  },
}));

const useListItemStyles = createStyles(() => ({
  itemWrapper: {
    width: "100%",
  },
}));

const useModalStyles = createStyles((theme) => ({
  close: {
    backgroundImage: "none",
    boxShadow: "none",
    color: "#868e96 !important",

    "&:focus": {
      boxShadow: "none",
    },

    "&:hover": {
      backgroundColor: theme.colors.shark[6],
      backgroundImage: "none",
      border: "none",
    },
  },
  inner: {
    zIndex: 10_000,
  },
}));

interface LinkedUsersModalProps {
  opened: boolean;
  onClose: () => void;
}

const LinkedUsersModal = ({ opened, onClose }: LinkedUsersModalProps) => {
  const { classes } = useStyles();
  const { classes: listItemClasses } = useListItemStyles();
  const { classes: modalClasses } = useModalStyles();
  const { data: currentUser } = useCurrentUser();

  const linkedUsersToTarget = currentUser?.linkedUsersToTarget ?? [];

  return (
    <Modal classNames={modalClasses} opened={opened} onClose={onClose} title="Switch user account">
      <List listStyleType="none" classNames={listItemClasses}>
        {linkedUsersToTarget.map((linkedUser) => (
          <List.Item key={linkedUser.id}>
            <Anchor
              className={classes.anchor}
              href={`/switch_to_user?target_user_id=${linkedUser.targetUserId}`}
              px={rem(25)}
              py={rem(10)}
            >
              {linkedUser.name}
            </Anchor>
          </List.Item>
        ))}
      </List>
    </Modal>
  );
};

export default LinkedUsersModal;
